enum PortTypes {
    basePort = 'base_port',
}

export default PortTypes;